import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({

  userStatusRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center",
    justifyContent: 'center',
    gap: '10px',
  },
}))
